<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Retiro
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col">
              <h4>Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="withdraw_details" v-if="loaded"/>
        <!--end: Details -->

        <!--begin: Attachments -->
          <div class="row mt-5">
            <div class="col">
              <h4>Anexos Afectados</h4>
            </div>
          </div>
          <div class="mt-2" v-if="attachments">
            <div class="row" v-if="attachments.cancelled">
              <div class="col">
                <h4 class="subtitle">Anexos Expirados</h4>
              </div>
            </div>
            <div class="row" v-if="attachments.cancelled">
              <div class="col">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Monto de inversión</th>
                      <th scope="col">Fecha de inicio</th>
                      <th scope="col">Fecha de vencimiento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="attachment in attachments.cancelled" :key="attachment.id">
                      <th scope="row" class="text-danger">{{ attachment.attachment_id }}</th>
                      <td>{{ attachment.amount | formatCurrency }}</td>
                      <td>{{ attachment.date_init }}</td>
                      <td>{{ withdraw_details.date_retirement.value | reverseDate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" v-if="attachments.new">
              <div class="col">
                <h4 class="subtitle">Anexos Renovados</h4>
              </div>
            </div>
            <div class="row" v-if="attachments.new">
              <div class="col">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Monto de inversión</th>
                      <th scope="col">Fecha de inicio</th>
                      <th scope="col">Fecha de vencimiento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="attachment in attachments.new" :key="attachment.id">
                      <th scope="row" class="text-success">{{ attachment.attachment_id }}</th>
                      <td>{{ attachment.amount | formatCurrency }}</td>
                      <td>{{ withdraw_details.date_retirement.value | reverseDate }}</td>
                      <td>{{ attachment.date_expire }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col">
              <p class="text-danger" v-if="error">
                {{ error }}
              </p>
              <h4 class="subtitle" v-else> - </h4>
            </div>
          </div>
        <!--end: Attachments -->
      </div>
      <div class="card-footer text-right" v-if="validated">
        <button class="btn btn-secondary card-btn" @click="clear">
          <fai icon="eraser"/> Limpiar
        </button>
        <button class="btn btn-success card-btn" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
      <div class="card-footer text-right" v-else>
        <button class="btn btn-secondary card-btn" @click="$router.push({ name: 'withdraws' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-info card-btn" :class="{ 'disabled': form.isSaving }" @click="getAttachments">
          <fai icon="clipboard-check"/> Validar retiro
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import withdrawsService from '@/services/withdraws'
import investorsService from '@/services/investors'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'WithdrawCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      contracts: {},
      attachments: null,
      withdraw_details: {
        investor_id: {
          name: 'Acreedor',
          hint: 'Seleccione un Acreedor',
          value: '',
          type: 'select',
          options: [],
          size: 12
        },
        contract_id: {
          name: 'Contrato',
          hint: 'Seleccione un Contrato',
          value: '',
          type: 'select',
          options: [],
          size: 12,
          validate: 'required'
        },
        total_investment: {
          name: 'Monto total de la Inversión',
          hint: '',
          value: '',
          type: 'number',
          disabled: true
        },
        amount: {
          name: 'Monto del Retiro',
          hint: 'Monto del Retiro',
          value: '',
          type: 'number',
          min: 0,
          validate: 'required'
        },
        date_retirement: {
          name: 'Fecha de Retiro',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date',
          validate: 'required'
        }
      },
      error: null,
      validated: false
    }
  },

  created: function () {
    this.loaded = false

    investorsService.withContracts().then(res => {
      this.withdraw_details.investor_id.options = res.map(investor => {
        if (investor.type == 'Moral') investor.fullname = investor.corporate_name
        return { value: investor.id, text: investor.fullname }
      })

      this.investors = res

      this.loaded = true
    })
  },

  methods: {
    clear: function () {
      this.attachments = null
      this.error = null
      this.validated = false
    },

    getAttachments: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.withdraw_details)

          body.date_confirm = body.date_retirement
          body.status = 0

          this.validated = false

          withdrawsService.preview(body).then(res => {
            if (res.error) {
              this.attachments = null
              this.error = res.error
            } else {
              this.attachments = res
              this.validated = true
            }
          }).catch(err => {
            this.attachments = null
            this.error = err.data.error
          })
        } else {
          this.error = 'Llene todos los campos del formulario para continuar'
        }
      })
    },

    saveForm: function () {
      let body = this.processForm(this.withdraw_details)

      body.date_confirm = body.date_retirement

      let service = withdrawsService.post(body)

      this.sendForm(service).then(res => {
        this.$router.push({ name: 'withdraws', props: { withdraw: res } })
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    }
  },

  watch: {
    withdraw_details: {
      handler: function (form, pastForm) { if (this.attachments) this.validated = false },
      deep: true
    },

    'withdraw_details.investor_id.value': function (newInvestor, oldInvestor) {
      this.withdraw_details.contract_id.value = null
      this.withdraw_details.contract_id.options = []

      if (!newInvestor) return

      investorsService.contracts(newInvestor.value).then(res => {
        this.withdraw_details.contract_id.options = res.map(contract => {
          return {
            value: contract.id,
            text: contract.folio,
            cut_day: contract.cut_day,
            interest_rate: contract.interest_rate,
            frequency: contract.frequency_name,
            amount: contract.total_investment
          }
        })
      })
    },

    'withdraw_details.contract_id.value': function (newContract, oldContract) {
      if (!newContract) {
        this.withdraw_details.total_investment.value = ''
        return
      }

      if (oldContract !== '') {
        this.withdraw_details.total_investment.value = newContract.amount
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .subtitle {
    font-size: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/withdraws/WithdrawCreate.vue